import React, { ReactNode, memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './AcConfigureNotificationDashboard.css'
import { CustomDialog, CustomSwitch, CustomTooltipWithLabel, DashboardHeader, DashboardLoader, HorizontalNavbar, LinkButton, SearchBox, SidePopover, TableDashboardTheme, TableLayout, TableSubHeader, alarmCardMapper, formatRelativeTimeForTable, renderHeaderActionButtons, useAppDispatch, useAppSelector, useEffectOnce } from '../../../globalUtils/globalExports';
import { fetchAlarmTypeOfNotification, fetchUsersReferenceData, getGlobalReducer, getReferenceDataReducer, setTableColumnPrefrences } from '../../../rmsReduxStore/reduxExports';
import { useLocation, useNavigate } from 'react-router-dom';
import { GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import { acConfigureNotificationDashboardNavList, acConfigureNotificationPopoverNavList } from './acConfigureNotificationConstant';
import { ActionIcons, IconWithTooltip } from '../../../globalUtils/globalIcons';
import access from '../../../auth/service/AccessControl';
import { cloneDeep } from 'lodash';
import { Id, toast } from 'react-toastify';
import HistoryPage from '../../../components/configureNotification/HistoryPage';
import { ThemeProvider } from '@mui/material';
import { downloadFile, formatDateForHistory } from '../../../globalUtils/globalHooks';
import RuleEngineGrid from '../../../globalUtils/GridViewCards/GridCards';
import SummaryPage, { ISummaryContentProp, ISummaryPageProps } from '../../../components/configureNotification/summaryPage';
import { HistorySidePopoverPage } from '../../../components/componentExports';
import NotificationTemplate from '../../../components/configureNotification/NotificationTemplate';
import { AcSmsRecipientInterface } from './AcCreateRule';
import { Menu, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import * as acConfigureNotificationTypes from '../../rmsReduxStore/acConfigureNotificationRedux/acConfigureNotificationTypes';
import { deleteAcConfigureNotification, exportAcNotificationHistoryData, fetchAcConfigureNotificationData, fetchAcConfigureNotificationHistoryData, fetchAcNotificationTemplate, setAcAlarmRuleStatus, setAcConfigurationNotificationHistoryListTableProps, setAcConfigurationNotificationListTableProps, setAcLatestConfigurationOnTop } from '../../rmsReduxStore/acConfigureNotificationRedux/acConfigureNotificationCreators';
import getAcConfigureNotificationReducer from '../../rmsReduxStore/acConfigureNotificationRedux/acConfigureNotificationSelector';
import { fetchAcAlarmRuleReferenceData, fetchAcChargerStationReferenceData, fetchAcChargerVisibleIdReferenceData, fetchAcRuleAlarmTypeReferenceData } from '../../rmsReduxStore/acReferenceDataRedux/acReferenceDataCreator';
import getAcReferenceDataReducer from '../../rmsReduxStore/acReferenceDataRedux/acReferenceDataSelector';
import { getAcFilterSelectedValue, getCurrentAcFiltersValues, getCurrentScreenAppliedAcFiltersCount, setAcFilterData } from '../../rmsReduxStore/acFiltersRedux/acFiltersCreators';
import { getAcFilterReducer } from '../../rmsReduxStore/acReduxExports';
import AcFilterLayout, { FilterProp } from '../../../globalUtils/FilterLayout/AcFilterLayout';

const AcConfigureNotificationDashboard = memo(function AcConfigureNotificationDashboard() {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const layouts = ['list', 'grid']
  const { screenTableColumnPrefrences } = useAppSelector(getGlobalReducer)
  const {
    acConfigureNotification,
    acConfigureNotificationHistory,
    acConfigureNotificationCount,
    acConfigureNotificationHistoryCount,
    acConfigureNotificationListTableProps,
    acConfigureNotificationHistoryListTableProps,
    acConfigureNotificationFiltersAppliedFromRedirection,
    acGetLatestConfigurationOnTop,
    acConfigureNotificationTableLoader } = useAppSelector(getAcConfigureNotificationReducer)

  const {
    alarmSeverityReferenceData,
    ruleAlarmTypeReferenceData,
    acAlarmRuleReferenceData,
    chargerVisibleIdReferenceData,
    chargingStationReferenceData,
  } = useAppSelector(getAcReferenceDataReducer);

  const { typeOfNotificationReferenceData, userReferenceData } = useAppSelector(getReferenceDataReducer);

  const [isSidePopOverOpen, setIsSidePopOverOpen] = useState(false);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const acConfigureNotificationRef = useRef(acConfigureNotification);
  const acConfigureNotificationHistoryRef = useRef(acConfigureNotificationHistory);
  const { screenFilters } = useAppSelector(getAcFilterReducer)
  const acConfigureNotificationListTablePropsRef = useRef(acConfigureNotificationListTableProps);
  const acConfigureNotificationHistoryListTablePropsRef = useRef(acConfigureNotificationHistoryListTableProps)
  const [layoutView, setLayoutView] = useState<string>(location?.state?.layoutView === 'grid' ? 'grid' : 'list');
  const [selectedNav, setSelectedNav] = useState<'acConfigureNotification' | 'acConfigureNotificationHistory'>('acConfigureNotification');
  const [singleNotification, setSingleNotification] = useState<IAcConfigureNotification | null>(null)
  const [selectedSidePopoverNav, setSelectedSidePopoverNav] = useState<'summary' | 'history'>('summary');
  const [chargerVisibleName, setChargerVisibleName] = useState('')
  const [selectedConfigureNotificationId, setSelectedConfigureNotificationId] = useState<string | null>(null);
  const [isNoProductTypeDialogOpen, setIsNoProductTypeDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const tableRef = useRef<HTMLDivElement>(null)
  const headerWrapRef = useRef<HTMLDivElement>(null)
  const searchWrapRef = useRef<HTMLDivElement>(null)
  const tableWrapRef = useRef<HTMLDivElement>(null)
  const subHeaderRef = useRef<HTMLDivElement>(null)
  const [forceRefreshId, setForceRefreshId] = useState(new Date().getTime())
  const [tableWrapHeight, setTableWrapHeight] = useState(0)
  const [openTemplateDialog, setOpenTemplateDialog] = useState<boolean>(false);
  const [showLoader, setShowLoader] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isSidePopOverExpanded, setIsSidePopOverExpanded] = useState<boolean | null>(false);
  const [exportingFile, setExportingFile] = useState(false);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [popoverExportAnchorEl, setPopoverExportAnchorEl] = useState<HTMLElement | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [templateResponse, setTemplateResponse] = useState<any>(null)

  const handleFireTimeClick = useCallback((logId) => {
    const callApi = async () => {
      const response = await fetchAcNotificationTemplate(logId ?? '');
      if (response?.status === 'SUCCESS') {
        setTemplateResponse(response?.data);
        setOpenTemplateDialog(true);
      } else {
        userDeletionFailureToast('something went wrong');
      }
    }
    if (logId) callApi()
  }, [openTemplateDialog, templateResponse])

  const handleSidePopOverExpansion = () => {
    setIsSidePopOverExpanded((isSidePopOverExpanded) => !isSidePopOverExpanded);
  }

  const updateSize = useCallback(() => {
    setForceRefreshId(new Date().getTime())
  }, [])

  useEffect(() => {
    acConfigureNotificationListTablePropsRef.current = acConfigureNotificationListTableProps;
  }, [acConfigureNotificationListTableProps]);

  useEffect(() => {
    acConfigureNotificationHistoryListTablePropsRef.current = acConfigureNotificationHistoryListTableProps;
  }, [acConfigureNotificationHistoryListTableProps]);

  useEffect(() => {
    acConfigureNotificationRef.current = acConfigureNotification;
  }, [acConfigureNotification]);

  useEffect(() => {
    acConfigureNotificationHistoryRef.current = acConfigureNotificationHistory;
  }, [acConfigureNotificationHistory]);

  useEffect(() => {
    const ro = new ResizeObserver(() => {
      updateSize()
    })
    if (tableRef.current != null) {
      ro.observe(tableRef.current)
    }
    window.addEventListener('resize', updateSize)
    return () => {
      window.removeEventListener('resize', updateSize)
    }
  }, [tableRef])

  useEffect(() => {
    const calculateTableWrapHeight = (): void => {
      if (((headerWrapRef?.current) != null) && ((searchWrapRef?.current) != null) && ((tableWrapRef?.current) != null)) {
        const totalHeight = tableWrapRef?.current?.getBoundingClientRect?.().height
        const headerHeight = headerWrapRef?.current?.getBoundingClientRect?.().height
        const searchHeight = searchWrapRef?.current?.getBoundingClientRect().height
        const subHeaderHeight = subHeaderRef?.current?.getBoundingClientRect?.().height ?? 0
        const tableWrapHeight = totalHeight - headerHeight - searchHeight - subHeaderHeight
        setTableWrapHeight(tableWrapHeight)
      }
    }
    calculateTableWrapHeight()
    window.addEventListener('resize', calculateTableWrapHeight)
    return () => {
      window.removeEventListener('resize', calculateTableWrapHeight)
    }
  }, [])

  useEffectOnce(() => {
    dispatch(fetchAcChargerStationReferenceData());
    dispatch(fetchAcChargerVisibleIdReferenceData({}));
    dispatch(fetchAcAlarmRuleReferenceData());
    dispatch(fetchAcRuleAlarmTypeReferenceData());
    dispatch(fetchAlarmTypeOfNotification());
    dispatch(fetchUsersReferenceData());
  });

  const acConfigureNotificationCleanUpStates = useCallback(() => {
    const action = {
      type: acConfigureNotificationTypes.CLEAR_AC_CONFIGURE_NOTIFICATION_LIST_DATA,
    }
    const action1 = {
      type: acConfigureNotificationTypes.CLEAR_AC_CONFIGURE_NOTIFICATION_HISTORY_LIST_DATA,
    }
    dispatch(action);
    dispatch(action1);
    dispatch(setAcLatestConfigurationOnTop(false))
    if (acConfigureNotificationFiltersAppliedFromRedirection) {
      onResetButtonClick(false)
    }
  }, [acConfigureNotificationFiltersAppliedFromRedirection])

  useEffect(() => {
    window.addEventListener('beforeunload', acConfigureNotificationCleanUpStates);
    return (): void => {
      acConfigureNotificationCleanUpStates()
      window.removeEventListener('beforeunload', acConfigureNotificationCleanUpStates);
    }
  }, [])

  const handleNotificationNameClick = async (e, rowData) => {
    e?.stopPropagation()
    setSingleNotification(rowData)
    popoverChargerAudienceSection(rowData);
    setIsSidePopOverOpen(true);
  };

  const onEditIconClick = (rowData) => {
    navigate('/ac/create-notification-rule', { state: { userId: rowData.id, mode: 'Edit', rowData: rowData } })
  }

  const handleDeleteDialogClose = useCallback(() => {
    setIsDeleteDialogOpen(false);
    setSelectedConfigureNotificationId(null);
  }, []);

  const onDeleteIconClick = useCallback(async (id: string): Promise<void> => {
    setSelectedConfigureNotificationId(id);
    setIsDeleteDialogOpen(true);
  }, []);

  const userDeletionSuccessToast = useCallback((): Id => {
    return toast.success('Rule deleted.');
  }, []);

  const userDeletionFailureToast = useCallback((message: string): Id => {
    return toast.warn(message ?? 'Something went wrong.');
  }, []);

  const handleDeleteUser = useCallback(async () => {
    handleDeleteDialogClose();
    setShowLoader(true);
    const { data, status } =
      await dispatch(deleteAcConfigureNotification(
        selectedConfigureNotificationId
      ));
    if ((status === 200 || status === 202) && data?.message === 'Success') {
      setShowLoader(false);
      userDeletionSuccessToast();
      layoutCallback(1, acConfigureNotificationListTablePropsRef?.current?.pageSize, acConfigureNotificationListTablePropsRef?.current?.view, acConfigureNotificationListTablePropsRef?.current?.sortBy, acConfigureNotificationListTablePropsRef?.current?.order, null, '');
    } else {
      setShowLoader(false);
      userDeletionFailureToast(data?.message)
    }
  }, [dispatch, selectedConfigureNotificationId, handleDeleteDialogClose, acConfigureNotificationListTablePropsRef?.current, showLoader]);

  const headerActionBtns = renderHeaderActionButtons({
    actionBtns:
      [
        {
          id: 'create_new_notification_btn',
          isAccessible: true,
          headerActionBtnClick: (): void => {
            navigate('/ac/create-notification-rule', { state: { mode: 'Create' } })
          }
        },
        {
          id: 'add_filter_btn',
          isAccessible: true,
          headerActionBtnClick: (): void => {
            setFiltersVisible(true);
          },
          badgeCount: getCurrentScreenAppliedAcFiltersCount(selectedNav, selectedNav === 'acConfigureNotificationHistory' ? false : true)
        },
        {
          id: 'export_csv_btn',
          isAccessible: selectedNav === 'acConfigureNotificationHistory',
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          headerActionBtnClick: (event): void => {
            setExportAnchorEl(event.currentTarget);
          },
        },
      ]
  })

  const sidePopoverHeaderActionBtns = useMemo(() => renderHeaderActionButtons({
    actionBtns:
      [
        {
          id: 'export_csv_btn',
          isAccessible: selectedSidePopoverNav === 'history',
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          headerActionBtnClick: (event): void => {
            setPopoverExportAnchorEl(event.currentTarget);
          },
        },
      ]
  }), [selectedSidePopoverNav])

  const handleLayoutToggle = useCallback(async (newLayoutVal) => {
    setLayoutView(newLayoutVal);
  }, [acConfigureNotificationRef?.current, acConfigureNotificationHistoryRef?.current])

  const notificationTimeLineCleanUpStates = useCallback(() => {
    const action = {
      type: acConfigureNotificationTypes.CLEAR_AC_CONFIGURE_NOTIFICATION_HISTORY_TIMELINE,
    }
    dispatch(action);
  }, [])

  const handleClosePopOver = (): void => {
    setIsSidePopOverOpen(false)
    setSingleNotification(null)
    setSelectedSidePopoverNav('summary')
    setChargerVisibleName('')
    setIsSidePopOverExpanded(false)
    notificationTimeLineCleanUpStates();
  }

  const handleNavBtnClick = useCallback(async (val) => {
    setSelectedNav(val);
    if (val === 'acConfigureNotification' && acConfigureNotificationListTablePropsRef?.current) {
      const tableProps: IAcConfigureNotificationTableProps = cloneDeep(acConfigureNotificationListTablePropsRef?.current)
      if (tableProps) {
        tableProps.view = layoutView
        tableProps.sortBy = acConfigureNotificationListTablePropsRef?.current?.sortBy;
        tableProps.order = acConfigureNotificationListTablePropsRef?.current?.order;
        tableProps.pageNumber = acConfigureNotificationListTablePropsRef?.current?.pageNumber;
        tableProps.pageSize = acConfigureNotificationListTablePropsRef?.current?.pageSize;
        tableProps.searchTerm = '';
      }
      const action = {
        type: acConfigureNotificationTypes.CLEAR_AC_CONFIGURE_NOTIFICATION_HISTORY_LIST_DATA,
      }
      dispatch(action);
      await dispatch(setAcConfigurationNotificationListTableProps(tableProps));
    } else if (val === 'acConfigureNotificationHistory' && acConfigureNotificationHistoryListTablePropsRef?.current) {
      const tableProps: IAcConfigureNotificationHistoryListTableProps = cloneDeep(acConfigureNotificationHistoryListTablePropsRef?.current)
      if (tableProps) {
        tableProps.view = layoutView
        tableProps.sortBy = acConfigureNotificationHistoryListTablePropsRef?.current?.sortBy;
        tableProps.order = acConfigureNotificationHistoryListTablePropsRef?.current?.order;
        tableProps.pageNumber = acConfigureNotificationHistoryListTablePropsRef?.current?.pageNumber;
        tableProps.pageSize = acConfigureNotificationHistoryListTablePropsRef?.current?.pageSize;
        tableProps.searchTerm = '';
      }
      await dispatch(setAcConfigurationNotificationHistoryListTableProps(tableProps))
    }
  }, [selectedNav]);

  const navBarconfigurations = useMemo(() => {
    return {
      selectedNav: selectedNav,
      navList: acConfigureNotificationDashboardNavList?.filter((nav) => nav?.isAccessible),
      onNavClick: handleNavBtnClick
    }
  }, [selectedNav, handleNavBtnClick])

  const actionIconsList = useMemo(() => {
    return [{ icon: 'pencilIcon', isAccessible: access?.users?.edit(), action: (_, rowData) => onEditIconClick(rowData) },
    { icon: 'deleteIcon', isAccessible: access?.users?.delete(), action: (_, rowData) => onDeleteIconClick(rowData?.id) }];
  }, [onDeleteIconClick]);

  const layoutsConfiguration = useMemo(() => {
    return [
      {
        toolTipText: 'List View',
        onIconClick: (): void => { handleLayoutToggle('list') },
        layout: 'list',
        iconClassName: 'configure__notification__header__list__icon'
      },
      {
        toolTipText: 'Grid View',
        onIconClick: (): void => { handleLayoutToggle('grid') },
        layout: 'grid',
        iconClassName: 'configure__notification__header__grid__icon'
      },
    ]
  }, [handleLayoutToggle])

  const getTableRows = useCallback((): IAcConfigureNotification[] => {
    return acConfigureNotification !== null && acConfigureNotification?.length > 0 ? acConfigureNotification : [];
  }, [acConfigureNotification]);

  const getAcConfigureNotificationHistoryTableRows = useCallback((): IAcConfigureNotificationHistory[] => {
    return acConfigureNotificationHistory !== null && acConfigureNotificationHistory?.length > 0 ? acConfigureNotificationHistory : [];
  }, [acConfigureNotificationHistory]);

  const onResetButtonClick = useCallback(async (callListApi: boolean) => {
    const res = await setAcFilterData(null, '', selectedNav === 'acConfigureNotification' ? selectedNav : 'acConfigureNotificationHistory', 'CLEAR', false, selectedNav === 'acConfigureNotification' ? true : false)(dispatch);
    if (res?.message === 'Action dispatched successfully') {
      if (selectedNav === 'acConfigureNotification' && acConfigureNotificationListTablePropsRef?.current && callListApi) {
        layoutCallback(1, acConfigureNotificationListTablePropsRef?.current?.pageSize, acConfigureNotificationListTablePropsRef?.current?.view, acConfigureNotificationListTablePropsRef?.current?.sortBy, acConfigureNotificationListTablePropsRef?.current?.order, res?.filters, acConfigureNotificationListTablePropsRef?.current?.searchTerm)
      } else if (selectedNav === 'acConfigureNotificationHistory' && acConfigureNotificationHistoryListTablePropsRef?.current && callListApi) {
        layoutCallbackAcConfigureNotificationHistory(1, acConfigureNotificationHistoryListTablePropsRef?.current?.pageSize, acConfigureNotificationHistoryListTablePropsRef?.current?.view, acConfigureNotificationHistoryListTablePropsRef?.current?.sortBy, acConfigureNotificationHistoryListTablePropsRef?.current?.order, res.filters, acConfigureNotificationHistoryListTablePropsRef?.current?.searchTerm);
      }
    }
  }, [selectedNav, acConfigureNotificationHistoryListTablePropsRef?.current, acConfigureNotificationListTablePropsRef?.current, acConfigureNotificationFiltersAppliedFromRedirection])

  const filterFooterBtns = useMemo(() => {
    return [
      {
        buttonText: 'Reset',
        buttonId: 'Reset' + selectedNav,
        btnClassName: 'secondary__btn',
        handleClick: (): Promise<void> => onResetButtonClick(true),
        isDisabled: false,
        buttonVariant: 'outlined',
      },
    ];
  }, [onResetButtonClick]);

  const renderStatusCell = (params: GridRenderCellParams<GridValidRowModel, Date>) => {
    const rowData = params?.row;
    const [localStatus, setLocalStatus] = useState(rowData?.status === 'Enabled');

    const handleToggleChange = async (e: React.MouseEvent) => {
      e.stopPropagation();
      setLocalStatus((prevStatus) => !prevStatus);
      const newStatus = !localStatus ? 'Enabled' : 'Disabled';
      try {
        const notificationsToUpdate = cloneDeep(acConfigureNotification)
        let updatedRuleStatus;
        const rowToUpdate = notificationsToUpdate?.find((row) => row?.id === rowData?.id);
        if (rowToUpdate) rowToUpdate.status = newStatus;
        // eslint-disable-next-line prefer-const
        updatedRuleStatus = rowToUpdate.status;

        dispatch({
          type: acConfigureNotificationTypes.FETCH_AC_CONFIGURE_NOTIFICATIONS,
          acConfigureNotification: notificationsToUpdate,
          acConfigureNotificationCount: acConfigureNotificationCount
        });
        await dispatch(setAcAlarmRuleStatus({
          id: rowData?.id,
          ruleStatus: updatedRuleStatus
        }));
      } catch (error) {
        console.error('Failed to update rule status:', error);
        setLocalStatus((prevStatus) => !prevStatus);
      }
    };

    return (
      <CustomSwitch
        switchId="rule__engine__single__notification__status-switch"
        switchClassName="rule__engine__single__notification__status-switch"
        checked={localStatus}
        switchLabelName={localStatus ? 'Enabled' : 'Disabled'}
        handleClick={handleToggleChange}
        isDisabled={false}
      />
    );
  };

  const handleToggleChange = async (id: string) => {
    const status = acConfigureNotification?.find((rule) => rule?.id === id)?.status
    const newStatus = !status ? 'Enabled' : 'Disabled';
    try {
      const notificationsToUpdate = cloneDeep(acConfigureNotification);
      const rowToUpdate = notificationsToUpdate?.find((row) => row?.id === id);
      if (rowToUpdate) rowToUpdate.status = newStatus;
      dispatch({
        type: acConfigureNotificationTypes.FETCH_AC_CONFIGURE_NOTIFICATIONS,
        acConfigureNotification: notificationsToUpdate,
        acConfigureNotificationCount: acConfigureNotificationCount
      });
      await dispatch(setAcAlarmRuleStatus({
        id: id,
        ruleStatus: rowToUpdate.status = newStatus
      }));
    } catch (error) {
      console.error('Failed to update rule status:', error);
    }
  };

  const popoverChargerAudienceSection = (rowData) => {
    if (rowData?.chargerIds && rowData?.chargerIds.length > 0 && rowData?.chargerIds[0] === 'All') {
      setChargerVisibleName('All');
    } else if (chargerVisibleIdReferenceData && rowData?.chargerIds != null) {
      const chargerVisibleNameData = rowData?.chargerIds.map(id => {
        const matchingObject = chargerVisibleIdReferenceData.find(obj => obj.label === id);
        return matchingObject ? matchingObject.label : null;
      }).filter(name => name !== null);
      setChargerVisibleName(chargerVisibleNameData?.join(','));
    }
  }

  const tableColumns = useMemo(() => {
    return [
      {
        field: 'name',
        headerName: 'Notification Rule Name',
        flex: 1,
        minWidth: 180,
        sortable: true,
        hideable: false,
        pinnable: false,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
          const rowData = params?.row as IAcConfigureNotification;
          return (
            <div className='configure__notification__dashboard__link__text'
              onClick={(e) => { handleNotificationNameClick(e, rowData); }}>
              <CustomTooltipWithLabel label={rowData?.name} labelId='ac-notification__name' />
            </div>
          );
        },
      },
      {
        field: 'description',
        headerName: 'Description',
        flex: 1,
        minWidth: 200,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          const rowData = params?.row;
          return (
            <div className='configure__notification__alarm'>
              <CustomTooltipWithLabel label={rowData?.description} labelId='ac-configure__notification__description' />
            </div>
          );
        },
      },
      {
        field: 'alarmSeverity',
        headerName: 'Category',
        flex: 1,
        minWidth: 120,
        maxWidth: 140,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          const rowData = params?.row;
          return (
            <div className="configure__notification__alarm" style={{ display: 'flex', gap: '6px' }}>
              {rowData?.alarmSeverity && rowData?.alarmSeverity?.includes('Critical') && <IconWithTooltip key={'critical__icon'} iconClassName={alarmCardMapper['CRITICAL']?.alarmSummaryIcon} toolTipText={alarmCardMapper['CRITICAL']?.title} />}
              {rowData?.alarmSeverity && rowData?.alarmSeverity?.includes('Major') && <IconWithTooltip key={'major__icon'} iconClassName={alarmCardMapper['MAJOR']?.alarmSummaryIcon} toolTipText={alarmCardMapper['MAJOR']?.title} />}
              {rowData?.alarmSeverity && rowData?.alarmSeverity?.includes('Minor') && <IconWithTooltip key={'minor__icon'} iconClassName={alarmCardMapper['MINOR']?.alarmSummaryIcon} toolTipText={alarmCardMapper['MINOR']?.title} />}
            </div>
          );
        },
      },
      {
        field: 'visibleAlarmName',
        headerName: 'Alarm',
        flex: 1,
        minWidth: 170,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          const rowData = params?.row;
          return (
            <div className='configure__notification__alarm'>
              <CustomTooltipWithLabel label={rowData?.visibleAlarmName?.join(',')} labelId='ac-configure__notification__visible__alarm__name' />
            </div>
          );
        },
      },
      {
        field: 'alarmContinuesFor',
        headerName: 'Alarm Continues For',
        flex: 0.5,
        minWidth: 200,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          return params?.row?.alarmContinuesFor ? <div>{params?.row?.alarmContinuesFor + ' min'}</div> : <div>-</div>
        },
      },
      {
        field: 'typeOfNotification',
        headerName: 'Notification Action',
        flex: 0.6,
        minWidth: 200,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          const isEmailSelected = params?.row?.notifyUsingEmail;
          const isSmsSelected = params?.row?.notifyUsingSms;
          return (
            <div className='configure__notification__alarm'>{isEmailSelected === 'Yes' && isSmsSelected === 'Yes' ? 'SMS and Email' : isEmailSelected === 'Yes' ? 'Email' : 'SMS'}</div>
          )
        },
      },
      {
        field: 'lastTriggerTime',
        headerName: 'Fire Time',
        flex: 0.7,
        minWidth: 140,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): ReactNode => {
          const rowData = params?.row;
          return rowData?.lastTriggerTime ? formatRelativeTimeForTable(new Date(rowData?.lastTriggerTime)) : '-';
        },
      },
      {
        field: 'createdBy',
        headerName: 'Created By',
        flex: 1,
        minWidth: 150,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): ReactNode => {
          const rowData = params?.row;
          return <CustomTooltipWithLabel label={rowData?.createdBy} labelId={'ac-alarm-notification-created-by'} />
        },
      },
      {
        field: 'updatedBy',
        headerName: 'Updated By',
        flex: 1,
        minWidth: 150,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): ReactNode => {
          const rowData = params?.row;
          return <CustomTooltipWithLabel label={rowData?.updatedBy} labelId={'ac-alarm-notification-updated-by'} />
        }
      },
      {
        field: 'createdAt',
        headerName: 'Created At',
        flex: 0.7,
        minWidth: 140,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): ReactNode => {
          const rowData = params?.row;
          return rowData?.createdAt ? formatRelativeTimeForTable(new Date(rowData?.createdAt)) : '-';
        },
      },
      {
        field: 'updatedAt',
        headerName: 'Updated At',
        flex: 0.7,
        minWidth: 140,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): ReactNode => {
          const rowData = params?.row;
          return rowData?.createdAt ? formatRelativeTimeForTable(new Date(rowData?.updatedAt)) : '-';
        },
      },
      {
        field: 'status',
        headerName: 'Enable/Disable',
        flex: 0.7,
        minWidth: 200,
        sortable: true,
        renderCell: renderStatusCell
      },
      {
        field: 'action',
        headerName: 'Action',
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          const rowData = params?.row;
          return (
            <div className='configure__notification__dashboard__action__icons__wrap'>
              <ActionIcons actionIconsList={actionIconsList} data={rowData} />
            </div>
          );
        },
      }
    ]
  }, [acConfigureNotification, singleNotification])

  const tableColumnsHistory = useMemo(() => {
    const columns = [
      {
        field: 'fireTime',
        headerName: 'Fire Time',
        flex: 0.3,
        minWidth: 180,
        sortable: true,
        hideable: false,
        pinnable: false,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
          const rowData = params?.row;
          return rowData?.fireTime ? <div className={'configure__notification__dashboard__link__text'} onClick={() => {
            handleFireTimeClick(rowData?.id);
          }}>{formatDateForHistory(rowData?.fireTime)}</div> : <div>{'-'}</div>;
        },
      },
      {
        field: 'ruleName',
        headerName: 'Notification Rule Name',
        flex: 0.3,
        minWidth: 180,
        sortable: true,
        hideable: false,
        pinnable: false,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
          const rowData = params?.row;
          return (
            <CustomTooltipWithLabel label={rowData?.ruleName} labelId={'ac-configure__notification__history__notification__name'} />
          );
        },
      },
      {
        field: 'alarmSeverity',
        headerName: 'Category',
        flex: 1,
        minWidth: 120,
        maxWidth: 140,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          const rowData = params?.row;
          const severityIcon = rowData?.alarmSeverity?.toUpperCase();
          const tooltipText = alarmCardMapper[severityIcon]?.title;
          return (
            <div className='configure__notification__alarm'>
              <IconWithTooltip iconClassName={alarmCardMapper[severityIcon]?.alarmSummaryIcon}
                toolTipText={tooltipText} />
            </div>
          );
        }
      },
      {
        field: 'alarmName',
        headerName: 'Alarm',
        flex: 0.5,
        minWidth: 150,
        sortable: true,
      },
      {
        field: 'chargerVisibleId',
        headerName: 'Charger',
        flex: 0.4,
        minWidth: 120,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
          const rowData = params?.row;
          return (
            rowData?.chargerId ?
              (<div className="individual__charger__wrap" onClick={(e) => { e?.stopPropagation() }}>
                <LinkButton
                  linkBtnId={rowData?.chargerId}
                  link={'/ac/charger?chargerId=' + rowData.chargerId}
                  btnClassName="individual__charger__text"
                  btnText={rowData?.chargerVisibleId}
                  linkBtnState={{ chargerId: rowData?.chargerId, charger: rowData }}
                />
              </div>) : (<div onClick={() => setIsNoProductTypeDialogOpen(true)}>{rowData?.chargerVisibleId}</div>)
          );
        },
      },
      {
        field: 'ocppId',
        headerName: 'OCPP Id',
        flex: 1,
        sortable: true,
        pinnable: false,
        minWidth: 120,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
          const rowData = params?.row
          return (
            <CustomTooltipWithLabel label={rowData?.ocppId} labelId={`ac-configure__notification__history__ocpp__id-${rowData?.id}`} />
          )
        }
      },
      {
        field: 'chargingStation',
        headerName: 'Charging Station',
        flex: 0.5,
        minWidth: 150,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          const rowData = params?.row;
          return (
            <div
              className="configure__notification__dashboard__link__text"
              onClick={(e) => {
                e.stopPropagation();
                navigate('/ac/station', { state: { id: rowData?.chargingStationId, mode: 'View', name: rowData?.chargingStation } });
              }}>
              <CustomTooltipWithLabel label={rowData?.chargingStation} labelId={'ac-configure__notification__history__charging__station'} />
            </div>
          )
        },
      },
      {
        field: 'customer',
        headerName: 'Customer',
        flex: 0.5,
        minWidth: 150,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel>): ReactNode => {
          const rowData = params?.row;
          return (
            <div
              className="configure__notification__dashboard__link__text"
              onClick={(e) => {
                e?.stopPropagation();
                navigate('/ac/customer', { state: { id: rowData?.customerId, mode: 'View', name: rowData?.customer } });
              }}
            >
              <CustomTooltipWithLabel label={rowData.customer} labelId={'ac-configure__notification__history__customer'} />
            </div>
          );
        },
      },
      {
        field: 'connectorType',
        headerName: 'Connector',
        flex: 0.5,
        minWidth: 200,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          return params?.row?.connectorType ? <div>{params?.row?.connectorType}</div> : <div>-</div>
        },
      },
      {
        field: 'alarmContinuesFor',
        headerName: 'Alarm Continues For',
        flex: 0.5,
        minWidth: 200,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          return params?.row?.alarmContinuesFor ? <div>{params?.row?.alarmContinuesFor + ' min'}</div> : <div>-</div>
        },
      },
      {
        field: 'typeOfNotification',
        headerName: 'Notification Action',
        flex: 0.6,
        minWidth: 200,
        sortable: true,
        renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
          const notifyUsingSms = params?.row?.notifyUsingSms;
          const notifyUsingEmail = params?.row?.notifyUsingEmail;
          return (
            <div className='configure__notification__alarm'>
              {(notifyUsingEmail === 'Yes' && notifyUsingSms === 'Yes') ? 'SMS and Email' : (notifyUsingEmail === 'Yes' && notifyUsingSms === 'No') ? 'Email' : 'SMS'}
            </div>
          )
        },
      },
    ]
    if (selectedNav === 'acConfigureNotification' && selectedSidePopoverNav === 'history') {
      const columnsToDiscard = ['customer', 'ruleName', 'connectorType'];
      const columnsToShow = columns?.filter((col) => !columnsToDiscard?.includes(col?.field))
      const fireTimeColumn = columnsToShow?.find((col) => col?.field === 'fireTime');
      return [fireTimeColumn].concat(columnsToShow?.filter((col) => col?.field !== 'fireTime'))
    }
    return columns
  }, [acConfigureNotificationHistory])

  const onChangeOfSearchText = useCallback(async (val) => {
    if (selectedNav === 'acConfigureNotification' && acConfigureNotificationListTablePropsRef?.current) {
      await layoutCallback(1, acConfigureNotificationListTablePropsRef?.current?.pageSize, acConfigureNotificationListTablePropsRef?.current?.view, acConfigureNotificationListTablePropsRef?.current?.sortBy, acConfigureNotificationListTablePropsRef?.current?.order, null, val)
    } else if (selectedNav === 'acConfigureNotificationHistory' && acConfigureNotificationHistoryListTablePropsRef?.current) {
      await layoutCallbackAcConfigureNotificationHistory(1, acConfigureNotificationHistoryListTablePropsRef?.current?.pageSize, acConfigureNotificationHistoryListTablePropsRef?.current?.view, acConfigureNotificationHistoryListTablePropsRef?.current?.sortBy, acConfigureNotificationHistoryListTablePropsRef?.current?.order, null, val);
    }
  }, [selectedNav, selectedSidePopoverNav, layoutView, acConfigureNotificationListTablePropsRef?.current, acConfigureNotificationHistoryListTablePropsRef?.current]);

  const searchBoxConfiguration = useMemo(() => {
    return {
      searchFieldId: 'manage-ac-configure-notification-search-box',
      searchFieldName: 'manage-ac-configure-notification-search-box',
      searchBoxClassName: 'manage-ac-configure-notification-search-box',
      handleSearch: onChangeOfSearchText,
    };
  }, [selectedNav, onChangeOfSearchText, layoutView, acConfigureNotificationListTablePropsRef?.current, acConfigureNotificationHistoryListTablePropsRef]);

  const layoutCallback = useCallback(async (pageNumber: number, pageSize: number, view: string, field: string, order: string, filterData, searchTerm) => {
    const tableProps: IAcConfigureNotificationTableProps = cloneDeep(acConfigureNotificationListTablePropsRef?.current)
    const filters = filterData ? filterData : getCurrentAcFiltersValues('acConfigureNotification', true)
    await dispatch(fetchAcConfigureNotificationData({
      view: view ?? layoutView,
      sortBy: acGetLatestConfigurationOnTop ? 'updatedAt' : field || acConfigureNotificationListTablePropsRef?.current?.sortBy,
      order: acGetLatestConfigurationOnTop ? 'descending' : order || acConfigureNotificationListTablePropsRef?.current?.order,
      pageSize,
      pageNumber,
      filters: filters,
      searchTerm: searchTerm != null && searchTerm != undefined ? searchTerm : acConfigureNotificationListTablePropsRef?.current?.searchTerm
    }));
    if (tableProps) {
      tableProps.view = view || layoutView
      tableProps.sortBy = acGetLatestConfigurationOnTop ? 'updatedAt' : field || acConfigureNotificationListTablePropsRef?.current?.sortBy
      tableProps.order = acGetLatestConfigurationOnTop ? 'descending' : order || acConfigureNotificationListTablePropsRef?.current?.order
      tableProps.pageNumber = pageNumber;
      tableProps.pageSize = pageSize;
      if (searchTerm != null && searchTerm != undefined) {
        tableProps.searchTerm = searchTerm;
      }
    }
    if (acGetLatestConfigurationOnTop) await dispatch(setAcLatestConfigurationOnTop(false))
    await dispatch(setAcConfigurationNotificationListTableProps(tableProps))
  }, [layoutView, acConfigureNotificationListTablePropsRef?.current, selectedNav, dispatch, acGetLatestConfigurationOnTop]);

  const layoutCallbackAcConfigureNotificationHistory = useCallback(async (pageNumber: number, pageSize: number, view: string, field: string, order: string, filterData, searchTerm) => {
    const tableProps: IAcConfigureNotificationHistoryListTableProps = cloneDeep(acConfigureNotificationHistoryListTablePropsRef.current)
    const filters = filterData ? filterData : getCurrentAcFiltersValues('acConfigureNotificationHistory')
    await dispatch(fetchAcConfigureNotificationHistoryData({
      view: view ?? layoutView,
      sortBy: field || acConfigureNotificationHistoryListTablePropsRef?.current?.sortBy,
      order: order || acConfigureNotificationHistoryListTablePropsRef?.current?.order,
      pageSize,
      pageNumber,
      filters: (selectedNav === 'acConfigureNotification' && selectedSidePopoverNav === 'history') ? filterData : filters,
      notificationId: (selectedNav === 'acConfigureNotification' && selectedSidePopoverNav === 'history') ? singleNotification?.id : null,
      searchTerm: searchTerm != null && searchTerm != undefined ? searchTerm : acConfigureNotificationHistoryListTablePropsRef?.current?.searchTerm
    }));
    if (tableProps) {
      tableProps.view = view || layoutView
      tableProps.sortBy = field || acConfigureNotificationHistoryListTablePropsRef?.current?.sortBy;
      tableProps.order = order || acConfigureNotificationHistoryListTablePropsRef?.current?.order;
      tableProps.pageNumber = pageNumber;
      tableProps.pageSize = pageSize;
      if (searchTerm != null && searchTerm != undefined) {
        tableProps.searchTerm = searchTerm;
      }
    }
    await dispatch(setAcConfigurationNotificationHistoryListTableProps(tableProps))
  }, [layoutView, acConfigureNotificationHistoryListTablePropsRef?.current, selectedNav, dispatch, selectedSidePopoverNav]);

  const handleColumnPrefrenceChange = useCallback(async (operation, data) => {
    if (selectedNav === 'acConfigureNotification') {
      await dispatch(setTableColumnPrefrences('acConfigureNotification', operation, data))
    } else if (selectedNav === 'acConfigureNotificationHistory') {
      await dispatch(setTableColumnPrefrences('acConfigureNotificationHistory', operation, data))
    }
  }, [selectedNav])

  const handleFiltersClosePopOver = (): void => {
    setFiltersVisible(false);
    handleDeleteDialogClose();
  }

  const acConfigureNotificationFilterProps: FilterProp[] = useMemo(() => {
    const filterCreatedAtValue = getAcFilterSelectedValue('alarmRuleCreatedAtInterval', 'acConfigureNotification', false);
    const filterUpdatedAtValue = getAcFilterSelectedValue('alarmRuleUpdatedAtInterval', 'acConfigureNotification', false);
    const acConfigureNotificationFilter: FilterProp[] = [
      {
        filterLabel: 'Category',
        filterType: 'dropdown',
        filterId: 'alarmSeverity',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('alarmSeverity', 'acConfigureNotification', false),
          selectOptions: alarmSeverityReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'alarmSeverity', false) },
          selectDropDownId: 'ac-configure-notification-alarm-severity-filter-dropdown',
          isMultiSelect: false,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Alarm',
        filterType: 'dropdown',
        filterId: 'alarmTypeId',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('alarmTypeId', 'acConfigureNotification', false),
          selectOptions: ruleAlarmTypeReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'alarmTypeId', false) },
          selectDropDownId: 'ac-configure-notification-alarm-name-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Notification Action',
        filterType: 'dropdown',
        filterId: 'typeOfNotification',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('typeOfNotification', 'acConfigureNotification', false),
          selectOptions: typeOfNotificationReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'typeOfNotification', false) },
          selectDropDownId: 'ac-configure-notification-type-of-notification-filter-dropdown',
          isMultiSelect: false,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Created By',
        filterType: 'dropdown',
        filterId: 'alarmRuleCreatedBy',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('alarmRuleCreatedBy', 'acConfigureNotification', false),
          selectOptions: userReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'alarmRuleCreatedBy', false) },
          selectDropDownId: 'ac-configure-notification-created-by-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Updated By',
        filterType: 'dropdown',
        filterId: 'alarmRuleUpdatedBy',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('alarmRuleUpdatedBy', 'acConfigureNotification', false),
          selectOptions: userReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'alarmRuleUpdatedBy', false) },
          selectDropDownId: 'ac-configure-notification-updated-by-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Created At',
        filterId: 'alarmRuleCreatedAtInterval',
        filterType: 'dateFilter' as 'dropdown' | 'dateFilter',
        dateFilterProps: {
          datePickerId: 'ac-configure-notification-created-at-date-picker',
          datePickerClassName: '',
          selectsRange: true,
          startDate: filterCreatedAtValue?.[0] ? new Date(filterCreatedAtValue?.[0]) : null,
          endDate: filterCreatedAtValue?.[1] ? new Date(filterCreatedAtValue?.[1]) : null,
          onChange: (val): void => { handleFilterDataChange(val, 'alarmRuleCreatedAtInterval', false); },
        }
      },
      {
        filterLabel: 'Updated At',
        filterId: 'alarmRuleUpdatedAtInterval',
        filterType: 'dateFilter' as 'dropdown' | 'dateFilter',
        dateFilterProps: {
          datePickerId: 'ac-configure-notification-updated-at-date-picker',
          datePickerClassName: '',
          selectsRange: true,
          startDate: filterUpdatedAtValue?.[0] ? new Date(filterUpdatedAtValue?.[0]) : null,
          endDate: filterUpdatedAtValue?.[1] ? new Date(filterUpdatedAtValue?.[1]) : null,
          onChange: (val): void => { handleFilterDataChange(val, 'alarmRuleUpdatedAtInterval', false); },
        }
      },
    ]
    return acConfigureNotificationFilter
  }, [alarmSeverityReferenceData, ruleAlarmTypeReferenceData, typeOfNotificationReferenceData, screenFilters, acConfigureNotificationListTablePropsRef?.current, acConfigureNotificationRef?.current, acConfigureNotificationHistoryRef?.current, layoutView, selectedNav])

  const acConfigureNotificationHistoryFilterProps: FilterProp[] = useMemo(() => {
    const filterFireTimeValue = getAcFilterSelectedValue('fireTime', 'acConfigureNotificationHistory', false);
    const acConfigureNotificationHistoryFilter: FilterProp[] = [
      {
        filterLabel: 'Charging Stations',
        filterType: 'dropdown',
        filterId: 'chargingStationId',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('chargingStationId', 'acConfigureNotificationHistory', false),
          selectOptions: chargingStationReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'chargingStationId', false) },
          selectDropDownId: 'ac-configure-notification-history-chargingStationId-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Chargers',
        filterType: 'dropdown',
        filterId: 'chargerId',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('chargerId', 'acConfigureNotificationHistory', false),
          selectOptions: chargerVisibleIdReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'chargerId', false) },
          selectDropDownId: 'ac-configure-notification-history-chargerId-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Notification Rule Name',
        filterType: 'dropdown',
        filterId: 'ruleId',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('ruleId', 'acConfigureNotificationHistory', false),
          selectOptions: acAlarmRuleReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'ruleId', false) },
          selectDropDownId: 'ac-configure-notification-history-ruleId-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Category',
        filterType: 'dropdown',
        filterId: 'alarmSeverity',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('alarmSeverity', 'acConfigureNotificationHistory', false),
          selectOptions: alarmSeverityReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'alarmSeverity', false) },
          selectDropDownId: 'ac-configure-notification-history-alarm-severity-filter-dropdown',
          isMultiSelect: false,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Alarm',
        filterType: 'dropdown',
        filterId: 'alarmTypeId',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('alarmTypeId', 'acConfigureNotificationHistory', false),
          selectOptions: ruleAlarmTypeReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'alarmTypeId', false) },
          selectDropDownId: 'ac-configure-notification-history-alarm-name-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Notification Action',
        filterType: 'dropdown',
        filterId: 'typeOfNotification',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('typeOfNotification', 'acConfigureNotificationHistory', false),
          selectOptions: typeOfNotificationReferenceData ?? [],
          handleSelectOptionChange: (val): void => { handleFilterDataChange(val, 'typeOfNotification', false) },
          selectDropDownId: 'ac-configure-notification-history-type-of-notification-filter-dropdown',
          isMultiSelect: false,
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Fire Time Range',
        filterType: 'dateFilter',
        filterId: 'acConfigureNotificationHistoryTimeStamp',
        dateFilterProps: {
          datePickerId: 'ac__configure__notification__history__time__stamp__date__picker',
          datePickerClassName: 'ac__configure__notification__history__time__stamp__date__picker',
          selectsRange: true,
          renderToBody: true,
          startDate: filterFireTimeValue?.[0] ? new Date(filterFireTimeValue?.[0]) : null,
          endDate: filterFireTimeValue?.[1] ? new Date(filterFireTimeValue?.[1]) : null,
          onChange: (val): void => { handleFilterDataChange(val, 'fireTime', false) },
        }
      },
    ]
    return acConfigureNotificationHistoryFilter
  }, [alarmSeverityReferenceData, chargingStationReferenceData, acAlarmRuleReferenceData, chargerVisibleIdReferenceData, ruleAlarmTypeReferenceData, typeOfNotificationReferenceData, screenFilters, acConfigureNotificationListTablePropsRef?.current, acConfigureNotificationRef?.current, layoutView, selectedNav])

  const handleFilterDataChange = useCallback(async (val, filterKey, isGlobal) => {
    const res = await setAcFilterData(val, filterKey, selectedNav === 'acConfigureNotification' ? 'acConfigureNotification' : 'acConfigureNotificationHistory', 'SET', isGlobal ? isGlobal : false, selectedNav === 'acConfigureNotification' ? true : false)(dispatch)
    if (res?.message === 'Action dispatched successfully') {
      if (selectedNav === 'acConfigureNotification' && acConfigureNotificationListTablePropsRef?.current) {
        await layoutCallback(1, acConfigureNotificationListTablePropsRef?.current?.pageSize, acConfigureNotificationListTablePropsRef?.current?.view, acConfigureNotificationListTablePropsRef?.current?.sortBy, acConfigureNotificationListTablePropsRef?.current?.order, res?.filters, acConfigureNotificationListTablePropsRef?.current?.searchTerm)
      } else if (selectedNav === 'acConfigureNotificationHistory' && acConfigureNotificationHistoryListTablePropsRef?.current) {
        await layoutCallbackAcConfigureNotificationHistory(1, acConfigureNotificationHistoryListTablePropsRef?.current?.pageSize, acConfigureNotificationHistoryListTablePropsRef?.current?.view, acConfigureNotificationHistoryListTablePropsRef?.current?.sortBy, acConfigureNotificationHistoryListTablePropsRef?.current?.order, res?.filters, acConfigureNotificationHistoryListTablePropsRef?.current?.searchTerm);
      }
    }
  }, [selectedNav, acConfigureNotificationListTablePropsRef?.current, dispatch, acConfigureNotificationRef?.current, acConfigureNotificationHistoryRef?.current, layoutView, acConfigureNotificationHistoryListTablePropsRef?.current])

  const getSmsRecipients = (smsRecipients) => {
    const data = smsRecipients?.map((item: AcSmsRecipientInterface) => item.countryCode + item.phoneNumber).join(',');
    return data;
  }

  const getEmailRecipients = (emailRecipients) => {
    const data = emailRecipients?.map((item) => item).join(',');
    return data;
  }

  const summaryInfoFormArray: ISummaryContentProp[] = [
    {
      sectionHeading: '',
      formObject: [
        { label: 'Notification Name', value: singleNotification?.name ?? '' },
        { label: 'Description', value: singleNotification?.description ?? '' }
      ]
    },
    {
      sectionHeading: 'Alert Logic',
      formObject: [
        { label: 'Alarm', value: singleNotification?.visibleAlarmName?.join(',') ?? '' },
        { label: 'Category', value: singleNotification?.alarmSeverity?.join(',') ?? '' },
        {
          label: singleNotification?.logicComplexity === 'Basic' ? null : 'Alarm continues for',
          value: singleNotification?.logicComplexity === 'Basic' ? null : singleNotification?.alarmContinuesFor?.toString() + ' min'
        },
      ]
    },
    {
      sectionHeading: 'Charger Selection',
      formObject: [
        { label: 'Charger', value: chargerVisibleName === '' ? '-' : chargerVisibleName, isFullWidth: true },
      ]
    },
    {
      sectionHeading: 'Notification Action',
      formObject: [
        {
          label: (singleNotification?.notifyUsingSms && singleNotification?.notifyUsingSms === 'Yes') ? 'SMS' : null,
          value: (singleNotification?.notifyUsingSms && singleNotification?.notifyUsingSms === 'Yes') ? getSmsRecipients(singleNotification?.smsRecipients) ?? '' : null,
          isFullWidth: singleNotification?.emailRecipients?.length === 0
        },
        {
          label: (singleNotification?.notifyUsingEmail && singleNotification?.notifyUsingEmail === 'Yes') ? 'Email' : null,
          value: (singleNotification?.notifyUsingEmail && singleNotification?.notifyUsingEmail === 'Yes') ? getEmailRecipients(singleNotification?.emailRecipients) ?? '' : null,
          isFullWidth: singleNotification?.smsRecipients?.length === 0
        }
      ]
    }
  ];

  const handleSidePopoverNavBtnClick = useCallback(async (val: 'summary' | 'history') => {
    setSelectedSidePopoverNav(val);
  }, [selectedSidePopoverNav]);

  const navBarconfigurationsSidePopover = useMemo(() => {
    return {
      selectedNav: selectedSidePopoverNav,
      navList: acConfigureNotificationPopoverNavList?.filter((nav) => nav?.isAccessible),
      onNavClick: handleSidePopoverNavBtnClick
    }
  }, [handleSidePopoverNavBtnClick, selectedSidePopoverNav])

  const summaryPageInfoProps: ISummaryPageProps = useMemo(() => {
    return {
      formContainerClassName: 'configure_notification_summary_info',
      formArray: summaryInfoFormArray
    };
  }, [singleNotification])

  const handleCardClick = (e, id: string) => {
    handleNotificationNameClick(e, acConfigureNotification?.find(data => data?.id === id))
  }

  const handleDelete = (id: string) => { onDeleteIconClick(id); }

  const handlePaginationChange = async (page) => {
    await layoutCallback(page, acConfigureNotificationListTablePropsRef?.current?.pageSize, acConfigureNotificationListTablePropsRef?.current?.view, acConfigureNotificationListTablePropsRef?.current?.sortBy, acConfigureNotificationListTablePropsRef?.current?.order, null, '')
  }

  const handlePageCountChange = async (count) => {
    await layoutCallback(acConfigureNotificationListTablePropsRef?.current?.pageNumber, count, acConfigureNotificationListTablePropsRef?.current?.view, acConfigureNotificationListTablePropsRef?.current?.sortBy, acConfigureNotificationListTablePropsRef?.current?.order, null, '')
  }

  const handleClose = (): void => { setExportAnchorEl(null); };

  const fileDownloadSuccessToast = useCallback((): Id => {
    setExportingFile(false);
    return toast.success('Notification logs downloaded.');
  }, []);

  const fileDownloadFailureToast = useCallback((): Id => {
    setExportingFile(false);
    return toast.warn('Something went wrong. Please export again.');
  }, []);

  const onExportBtnClick = useCallback(async (fileType: 'csv' | 'xlsx'): Promise<void> => {
    if (exportingFile) return;
    try {
      const response: AxiosResponse = await dispatch(exportAcNotificationHistoryData({
        fileType,
        sortBy: acConfigureNotificationHistoryListTablePropsRef?.current?.sortBy,
        order: acConfigureNotificationHistoryListTablePropsRef?.current?.order,
        filters: getCurrentAcFiltersValues('acConfigureNotificationHistory')
      }));
      if (response?.status === 202 || response?.status === 200) {
        downloadFile({ url: response?.data?.url });
        fileDownloadSuccessToast()
      } else {
        fileDownloadFailureToast();
        setExportAnchorEl(null);
      }
    } finally {
      setExportingFile(false);
      setExportAnchorEl(null);
    }
  }, [exportingFile, fileDownloadSuccessToast, fileDownloadFailureToast, selectedNav])


  return (
    <>
      <DashboardLoader showLoader={showLoader} />
      <ThemeProvider theme={TableDashboardTheme}>
        <div className={'rms__table__dashboard ' + 'configure_notification'} ref={tableWrapRef}>
          <div className="rms__table__dashboard-header-wrap" ref={headerWrapRef}>
            <DashboardHeader
              headerClassName={'rms__table__dashboard-header'}
              header={'AC Notifications'}
            />
            <div className="rms__table__dashboard-sub-header-wrap">
              <div className='rms__table__dashboard-sub-header-wrap-buttons'>
                <TableSubHeader headerActionBtns={headerActionBtns} />
                <Menu
                  id="ac-export-option-dropdown"
                  anchorEl={exportAnchorEl}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  keepMounted
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  className='export__option__dropdown'
                  sx={{ top: '30px' }}
                  open={Boolean(exportAnchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem>
                    <div className='export__btn-option' onClick={(e) => { e?.stopPropagation(); onExportBtnClick('csv') }}>
                      To CSV
                    </div>
                  </MenuItem>
                  <MenuItem>
                    <div className='export__btn-option' onClick={(e) => { e?.stopPropagation(); onExportBtnClick('xlsx') }}>
                      To Excel
                    </div>
                  </MenuItem>
                </Menu>
              </div>
              <div className="rms__table__dashboard__view__options__wrap">
                {selectedNav === 'acConfigureNotification' && layouts !== null && Array.isArray(layouts) && layouts?.length > 0 &&
                  layouts?.map((layout, index) => {
                    const layoutConfig = layoutsConfiguration?.find((config) => config?.layout === layout)
                    if (layoutConfig != null) {
                      return (
                        <IconWithTooltip
                          key={index}
                          toolTipText={layoutConfig.toolTipText}
                          onIconClick={() => layoutConfig?.onIconClick?.()}
                          iconClassName={layoutView === layoutConfig.layout ? layoutConfig.iconClassName + ' selected' : layoutConfig.iconClassName ?? ''}
                        />
                      )
                    }
                    return null
                  })}
              </div>
            </div>
          </div>

          <div className="rms__table__dashboard__search__wrap" ref={searchWrapRef}>
            <div className="rms__table__dashboard__search__wrap-left">
              <SearchBox
                key={'searchBox' + selectedNav}
                searchFieldId={searchBoxConfiguration?.searchFieldId ?? ''}
                searchFieldName={searchBoxConfiguration?.searchFieldName ?? ''}
                searchBoxClassName={searchBoxConfiguration?.searchBoxClassName ?? ''}
                handleSearch={searchBoxConfiguration?.handleSearch}
              />
            </div>
          </div>

          <div ref={subHeaderRef} className="configure__notification__container__sub__header">
            <div className='configure__notification__container__sub__header__left'>
              <HorizontalNavbar
                selectedNav={navBarconfigurations?.selectedNav}
                onNavClick={(event, val) => { event?.stopPropagation(); navBarconfigurations?.onNavClick?.(val) }}
                navList={navBarconfigurations?.navList}
              />
            </div>
          </div>

          <div
            className="rms__table__dashboard__table__wrap"
            style={{ height: `${tableWrapHeight - 20}px`, display: 'block' }}
          >
            {selectedNav === 'acConfigureNotification' ?
              (layoutView === 'list' ? (
                <TableLayout
                  tableRows={getTableRows()}
                  gridColumns={tableColumns}
                  layoutView={layoutView}
                  listLayoutCallBack={layoutCallback}
                  totalCount={acConfigureNotificationCount}
                  showLoader={acConfigureNotificationTableLoader}
                  showSkeleton={!acConfigureNotification}
                  totalCountText={'Notification Rules'}
                  pageNumber={acConfigureNotificationListTableProps?.pageNumber}
                  tablePageSize={acConfigureNotificationListTableProps?.pageSize}
                  sortField={acConfigureNotificationListTableProps?.sortBy}
                  sortOrder={acConfigureNotificationListTableProps?.order}
                  refreshId={forceRefreshId}
                  columnPrefrences={screenTableColumnPrefrences?.find((item) => item.screen === 'acConfigureNotification')}
                  handleColumnPrefrenceChange={handleColumnPrefrenceChange}
                  leftPinnedColumns={['name']}
                  enableDisableBackgroundColourChange={true}
                />) :
                <RuleEngineGrid
                  cardClassName='configure_notification_card'
                  ruleDetail={acConfigureNotification}
                  screen='configureNotificaion'
                  handleToggleChange={handleToggleChange}
                  handleDelete={handleDelete}
                  handleCardClick={handleCardClick}
                  handlePaginationChange={handlePaginationChange}
                  handlePageCountChange={handlePageCountChange}
                  countText={'Notification Rules'}
                  pageNumber={acConfigureNotificationListTableProps?.pageNumber}
                  tablePageSize={acConfigureNotificationListTableProps?.pageSize}
                  totalCount={acConfigureNotificationCount}
                  listLayoutCallBack={layoutCallback}
                />)
              : <HistoryPage
                gridColumns={tableColumnsHistory}
                tableRows={getAcConfigureNotificationHistoryTableRows()}
                totalCount={acConfigureNotificationHistoryCount}
                listLayoutCallBack={layoutCallbackAcConfigureNotificationHistory}
                showLoader={acConfigureNotificationTableLoader}
                totalCountText={'Notification Rules'}
                showSkeleton={!acConfigureNotificationHistory}
                pageNumber={acConfigureNotificationHistoryListTableProps?.pageNumber}
                tablePageSize={acConfigureNotificationHistoryListTableProps?.pageSize}
                sortField={acConfigureNotificationHistoryListTableProps?.sortBy}
                sortOrder={acConfigureNotificationHistoryListTableProps?.order}
                columnPrefrences={screenTableColumnPrefrences?.find((item) => item.screen === 'acConfigureNotificationHistory')}
                handleColumnPrefrenceChange={handleColumnPrefrenceChange}
                leftPinnedColumns={['fireTime', 'ruleName']}
              />}
          </div>
        </div>
      </ThemeProvider>

      {isSidePopOverOpen && <SidePopover
        id='ac__configure__notification__detail__popover'
        open={isSidePopOverOpen}
        containerClassName='configure__notification__detail__popover'
        handleClose={handleClosePopOver}
        navBarconfigurations={navBarconfigurationsSidePopover}
        headerSecondaryText={selectedNav === 'acConfigureNotification' && selectedSidePopoverNav === 'history' ? singleNotification?.name : ''}
        popperClassName={isSidePopOverExpanded ? 'configure-notification' : 'configure-notification-not-expandable'}
        isSidePopOverExpanded={isSidePopOverExpanded}
        showExpandableIcon={true}
        handleSidePopOverExpansion={handleSidePopOverExpansion}
        isEditButtonVisible={true}
        onEditButtonClick={() => onEditIconClick(singleNotification)}
        headerActionBtns={sidePopoverHeaderActionBtns}
        // eslint-disable-next-line react/no-children-prop
        children={
          <>
            {selectedSidePopoverNav === 'summary' && <SummaryPage {...summaryPageInfoProps} />}
            {selectedSidePopoverNav === 'history' && <HistorySidePopoverPage
              gridColumns={tableColumnsHistory}
              tableRows={getAcConfigureNotificationHistoryTableRows()}
              totalCount={acConfigureNotificationHistoryCount}
              listLayoutCallBack={layoutCallbackAcConfigureNotificationHistory}
              showLoader={acConfigureNotificationTableLoader}
              totalCountText={'Notifications'}
              pageNumber={acConfigureNotificationHistoryListTableProps?.pageNumber}
              tablePageSize={acConfigureNotificationHistoryListTableProps?.pageSize}
              sortField={acConfigureNotificationHistoryListTableProps?.sortBy}
              sortOrder={acConfigureNotificationHistoryListTableProps?.order}
              columnPrefrences={screenTableColumnPrefrences?.find((item) => item.screen === 'acConfigureNotificationHistory')}
              handleColumnPrefrenceChange={handleColumnPrefrenceChange}
              leftPinnedColumns={['ruleName']}
              notificationId={singleNotification?.id}
              exportAnchor={[popoverExportAnchorEl, setPopoverExportAnchorEl]}
            />}
          </>
        }
      />
      }

      {filtersVisible && <SidePopover
        id={'ac__configure__notification__side__filters'}
        open={filtersVisible}
        containerClassName='configure__notification__side__filters'
        handleClose={handleFiltersClosePopOver}
        headerText={'Add Filters'}
        // eslint-disable-next-line react/no-children-prop
        children={
          <AcFilterLayout
            requiredReferenceDataCallbacks={selectedNav === 'acConfigureNotification' ? ['alarmSeverity', 'alarmTypeId', 'typeOfNotification', 'alarmRuleCreatedBy'] : ['chargingStationId', 'ruleId', 'chargerVisibleId', 'alarmSeverity', 'alarmTypeId', 'typeOfNotification']}
            filters={selectedNav === 'acConfigureNotification' ? acConfigureNotificationFilterProps : acConfigureNotificationHistoryFilterProps}
            handleFilterDataChange={handleFilterDataChange}
            excludeGlobalFilters={selectedNav === 'acConfigureNotification' ? true : false}
          />
        }
        btnsList={filterFooterBtns}
      />
      }

      {<CustomDialog
        dialogConfig={{
          dialogDescription: 'Are you sure you want to delete this rule?',
          dialogCancelTitle: 'Cancel',
          dialogOkTitle: 'Delete',
        }}
        show={isDeleteDialogOpen}
        handleClose={handleDeleteDialogClose}
        handleSubmit={handleDeleteUser}
        deleteLoader={showLoader}
      />}

      {<CustomDialog
        dialogConfig={{
          dialogDescription: 'Charger information is not available, as the charger has not yet communicated with RMS.',
          dialogOkTitle: 'Close',
        }}
        show={isNoProductTypeDialogOpen}
        handleSubmit={() => { setIsNoProductTypeDialogOpen(false) }}
      />}

      {openTemplateDialog && <NotificationTemplate open={openTemplateDialog} onClose={() => setOpenTemplateDialog(false)} templateResponse={templateResponse} />}
    </>
  )
})

export default AcConfigureNotificationDashboard
